module.exports = __webpack_public_path__ + "img/offers7.6e532566.webp";